import {ModalWithNewForm, Select, Message} from '~/components'
import {Input} from '@eitje/web_components'
import {useParams} from '@eitje/bridge'
import {Environment, Organisation} from '@eitje/api'
import {goBack} from '~/routing/actions'
import {INSTRUCTIONS_URL} from '../../constants'

export const MigrateEnvironment = () => {
	const {id} = useParams()

	const environment = Environment.useFind(id)
	const organisations = Organisation.useAll()
	const {naam, organisation_id} = environment

	return (
		<ModalWithNewForm
			name="migrate_environment"
			onSubmit={params => environment.update(params)}
			afterSubmit={goBack}
			modalProps={{
				confirmSubmit: true,
				okButtonProps: {
					t: 'common.save',
					iconLeft: 'checked',
					confirmText: {mdT: ['modals.migrate_environment.confirm_message', {INSTRUCTIONS_URL}]},
					confirmButtonProps: {t: 'modals.migrate_environment.confirm_button', iconLeft: null},
				},
			}}
			width={348}
			initialValues={{naam, organisation_id}}
		>
			<Message mdT={['modals.migrate_environment.message', {INSTRUCTIONS_URL}]} />
			<Input field="naam" readOnly />
			<Select field="organisation_id" items={organisations} />
		</ModalWithNewForm>
	)
}
